import { Component, OnInit } from '@angular/core';
import { StateService } from '../../services/state.service';
import { GoogleMapService } from '../../services/google-map.service';
import { VehicleService } from '../../services/vehicle.service';

@Component({
  selector: 'app-gmap',
  templateUrl: './gmap.component.html',
  styleUrls: ['./gmap.component.css']
})
export class GmapComponent implements OnInit {

  constructor(private stateSvc: StateService, private gmapSvc: GoogleMapService, private vehicleSvc: VehicleService) { }
  
  map:any = {};
  markers = [];
  infoContent = '';
  vehicles:any = [];
  openedInfoWdws = [];
  bounds:any = {};
  vehicleSubs:any;
  showPois = false;
  showZones = false;
  showControls = true;
  showMultipleOnMap = false;
  
  poisList:any = [];
  zonesList:any = [];
  
  zoom = 12;
  center = {
		lat: 3.129958,
		lng: 101.67509
	};

  ngOnInit(): void {
	//this.map = this.gmapSvc.initOnMap();
	this.map = new google.maps.Map(document.getElementById("gmp") as HTMLElement, {
		zoom: this.zoom,
		center: this.center
	});
	this.stateSvc.setMapInstance(this.map);
	this.vehicleSubs = this.stateSvc.vehicles
	.subscribe((result) => {
		let vhcls = result;
		this.vehicles = vhcls;
		let hadShownVehicle = false;
		this.vehicles?.forEach((vhcl) => {
			if(vhcl.shownOnMap && this.map?.mapTypeId){
				hadShownVehicle = true;
				return;
			}
		});
		if(!hadShownVehicle && !this.showPois && !this.showZones){
			this.map.setZoom(this.zoom);
		}
	});
	this.stateSvc.showMultipleOnMap
	.subscribe((result) => {
		this.showMultipleOnMap = result;
	});
	this.vehicleSvc.processUserPois(this.map);
	this.vehicleSvc.processUserZones(this.map);
	this.stateSvc.userPois
	.subscribe((pois) => {
		this.poisList = pois;
	});
	this.stateSvc.userZones
	.subscribe((zones) => {
		this.zonesList = zones;
	});
	this.map.initialZoom = true;
	google.maps.event.addListener(this.map, 'zoom_changed', () => {
		let zoomLevel = this.map.getZoom();
		if(zoomLevel > 14){
			// this.map.setZoom(14);
		}
		this.drawPois();
		this.drawZones();
		let zoomChangeBoundsListener = 
			google.maps.event.addListener(this.map, 'bounds_changed', function(event) {
				if (this.getZoom() > 15 && this.initialZoom == true) {
					// Change max/min zoom here
					this.setZoom(15);
					this.initialZoom = false;
				}
			google.maps.event.removeListener(zoomChangeBoundsListener);
		});
	});
	google.maps.event.addListener(this.map, 'tilesloaded', () => {
		console.log('siap')
		this.stateSvc.setMapLoaded(false);
	})
  }
  
  ngOnDestroy(){
	this.vehicleSubs.unsubscribe();
  }
  
  poiToggle(){
	this.showPois = !this.showPois;
	this.drawPois();
  }
  
  zonesToggle(){
	this.showZones = !this.showZones;
	this.drawZones();
  }
  
  resetZoom(){
	this.bounds = new google.maps.LatLngBounds();
	let hadShownVehicle = false;
	this.vehicles.forEach((vehicle) => {
		if (vehicle.marker?.getMap()) {
			this.bounds.extend(vehicle.marker.getPosition());
		}
		if(vehicle.shownOnMap){
			hadShownVehicle = true;
		}
	});
	if(this.map?.mapTypeId && this.bounds && hadShownVehicle){
		this.map.fitBounds(this.bounds);
	}else if(!hadShownVehicle){
		this.map.setZoom(this.zoom);
	}
  }
  
  toggleShowControl(){
	this.showControls = !this.showControls; 
	this.stateSvc.setShowControl(this.showControls);
  }
  
  drawPois(){
	let zoom = this.map.getZoom();
	if (this.showPois) {
		this.poisList.forEach((poi) => {
			poi.setMap(this.map);
		});
	} else {
		this.poisList.forEach((poi) => {
			poi.setMap(null);
		});
	}
  }
  
  drawZones(){
	let zoom = this.map.getZoom();
	if (zoom >= 14 && this.showZones) {
		this.zonesList.forEach((zone) => {
			!zone.getMap() && zone.setMap(this.map);
		});
	}else {
		this.zonesList.forEach((zone) => {
			zone.getMap() && zone.setMap();
		});
	}
  }

  mapProviderToggle(){
    this.stateSvc.setMapType('OpenStreetMap');
    window.location.reload(true);
  }
}
